import { useNavigate } from 'react-router-dom'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import s from './PipelineGuideModal.scss'

const PipelineGuideModal = ({ setShowPipelineGuideModal, showPipelineGuideModal }) => {
  const navigate = useNavigate()

  const toggleModal = () => setShowPipelineGuideModal(!showPipelineGuideModal)
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showPipelineGuideModal}
        toggle={toggleModal}
        size="m"
      >
        <ModalHeader toggle={toggleModal} className={s.modalHeader}>
          New pipeline stage created
        </ModalHeader>
        <ModalBody className={s.modalBody}>
          <div className={s.content}>
            Remember to also update your personal pipeline stage order and views. Would you make
            these updates now?
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className={s.saveBtn}
            onClick={() => {
              toggleModal()
              navigate('/admin?tab=personalSettings')
            }}
          >
            Yes
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            I will update my personal pipeline later
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default PipelineGuideModal
